module.exports = __webpack_public_path__ + "img/lg_ring_y_l_0_0.1b0d618e.png";